import { Link } from "react-router-dom";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const Tc = () => {
  const homeMenu = [
    // { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    { label: "School Profile ", link: "/schoolprofile" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Transfer Certificate"
                breadEnd="Transfer Certificate"
                breadMid="Transfer Certificate"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 text-box">
              <div className="time-table table tctable">
                <table className="wid-100" border="1">
                  <thead>
                    <tr>
                      <th scope="col">Admission No.</th>
                      <th scope="col">Student Name</th>
                      <th scope="col">TC No.</th>
                      <th scope="col">Issue Date</th>
                      <th scope="col">View TC</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>LVG/2239</td>
                      <td>VENAVIR JAIN</td>
                      <td>193</td>
                      <td>10.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/VENAVIR-JAIN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4698</td>
                      <td>tanmay sharma</td>
                      <td>171</td>
                      <td>01.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/tanmay-sharma.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3478</td>
                      <td>SWARNIV DALMIA</td>
                      <td>191</td>
                      <td>06.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SWARNIV-DALMIA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/2268</td>
                      <td>SVANIK GHAI</td>
                      <td>203</td>
                      <td>20.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SVANIK-GHAI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4783</td>
                      <td>SMAHI VIJAY</td>
                      <td>99</td>
                      <td>19.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SMAHI-VIJAY.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/754</td>
                      <td>SIDDHARTH SUDHIR NAIR</td>
                      <td>99</td>
                      <td>19.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SIDDHARTH-SUDHIR-NAIR.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/1181</td>
                      <td>ROSHNI MALL</td>
                      <td>101</td>
                      <td>19.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ROSHNI-MALL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/4644</td>
                      <td>PRISHA</td>
                      <td>186</td>
                      <td>06.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/PRISHA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4121</td>
                      <td>NAVYA GARG</td>
                      <td>145</td>
                      <td>25.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/NAVYA-GARG.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4130</td>
                      <td>KHALIL WALI</td>
                      <td>140</td>
                      <td>25.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KHALIL-WALI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3954</td>
                      <td>JASMEH KAUR SODHI</td>
                      <td>195</td>
                      <td>10.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/JASMEH-KAUR-SODHI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/929</td>
                      <td>HARSHIL GUPTA</td>
                      <td>198</td>
                      <td>07.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/HARSHIL-GUPTA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1727</td>
                      <td>GAURANG PATHAK</td>
                      <td>100</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/GAURANG-PATHAK.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2747</td>
                      <td>EASHAAN SINGH AULAKH</td>
                      <td>205</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/EASHAAN-SINGH-AULAKH.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3900</td>
                      <td>ANHAD SINGH SODHI</td>
                      <td>194</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANHAD-SINGH-SODHI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1723</td>
                      <td>ANVI GOEL</td>
                      <td>159</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANVI-GOEL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4122</td>
                      <td>AYAAN GARG</td>
                      <td>146</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/AYAAN-GARG.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1807</td>
                      <td>DVIJ AGRAWAL</td>
                      <td>190</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/DVIJ-AGRAWAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4547</td>
                      <td>Aadit Deepankar</td>
                      <td>154</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/aadit-deepankar.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2757</td>
                      <td>Adarsh gupta</td>
                      <td>200</td>
                      <td>10.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ADARSH-GUPTA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2281</td>
                      <td>ADHYAYAN KHURANA</td>
                      <td>177</td>
                      <td>06.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ADHYAYAN-KHURANA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2757</td>
                      <td>ADITI KUMAR</td>
                      <td>1250</td>
                      <td>06.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ADITI-KUMAR.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/394</td>
                      <td>ANANYA BATRA</td>
                      <td>208</td>
                      <td>30.03.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANANYA-BATRA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4548</td>
                      <td>ANAYA DEEPANKAR</td>
                      <td>149</td>
                      <td>10.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANAYA-DEEPANKAR.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2757</td>
                      <td>Adarsh gupta</td>
                      <td>200</td>
                      <td>10.04.22</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/NIRAGHA-BRAHMASAMUDRAM.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4764</td>
                      <td>NIRAGHA BRAHMASAMUDRAM</td>
                      <td>130</td>
                      <td>14.06.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/NIRAGHA-BRAHMASAMUDRAM.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1331</td>
                      <td>VIDHYAANSH KOHLI</td>
                      <td>219</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/VIDHYAANSH-KOHLI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/920</td>
                      <td>UNNATI SAXENA</td>
                      <td>168</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/UNNATI-SAXENA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/21</td>
                      <td>SWARAANSH MITTAL</td>
                      <td>222</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SWARAANSH-MITTAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/3369</td>
                      <td>PRISHA DALAL</td>
                      <td>196</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/PRISHA-DALAL-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1415</td>
                      <td>PREETHI KANNAN</td>
                      <td>210</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/PREETHI-KANNAN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2957</td>
                      <td>PRATHAM LAL</td>
                      <td>198</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/PRATHAM-LAL-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1447</td>
                      <td>PARTH YADAV</td>
                      <td>210</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/PARTH-YADAV-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4764</td>
                      <td>Niragha</td>
                      <td>70</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/niragha.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2057</td>
                      <td>MYRA DHOKE</td>
                      <td>70</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/MYRA-DHOKE-2021.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1330</td>
                      <td>MAHIRA KOHLI</td>
                      <td>218</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/MAHIRA-KOHLI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3848</td>
                      <td>MADHAV SINGLA</td>
                      <td>215</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/MADHAV-SINGLA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3975</td>
                      <td>KRISHYANGI DIXIT</td>
                      <td>213</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KRISHYANGI-DIXIT-VIII.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2846</td>
                      <td>KIMAYA JAIN</td>
                      <td>22</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KIMAYA-JAIN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3002</td>
                      <td>KESHAV RAJ</td>
                      <td>214</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KESHAV-RAJ-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4266</td>
                      <td>KASTURI KULKARNI</td>
                      <td>149</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KASTURI-KULKARNI-2021.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3270</td>
                      <td>ISAIAH GEORGE</td>
                      <td>19</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ISAIAH-GEORGE.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/79</td>
                      <td>IRENE VEENUN CHERIYAN</td>
                      <td>199</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/IRENE-VEENUN-CHERIYAN-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4094</td>
                      <td>IANA MARIAM GEORGE</td>
                      <td>20</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/IANA-MARIAM-GEORGE.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2375</td>
                      <td>EKLAVYA AGARWAL</td>
                      <td>208</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/EKLAVYA-AGARWAL-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3053</td>
                      <td>DIVYANSHI VERMA</td>
                      <td>223</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/DIVYANSHI-VERMA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3556</td>
                      <td>DIVYANKA DIXIT</td>
                      <td>212</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/DIVYANKA-DIXIT-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1519</td>
                      <td>DHRITI THAKUR</td>
                      <td>202</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/DHRITI-THAKUR-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3637</td>
                      <td>DANICA SAKHUJA</td>
                      <td>203</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/DANICA-SAKHUJA-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1692</td>
                      <td>AYAAN JAIN</td>
                      <td>21</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/AYAAN-JAIN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/633</td>
                      <td>ARNAV GUPTA</td>
                      <td>216</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ARNAV-GUPTA-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2010</td>
                      <td>ANNANYA NSUBRAMANIAN</td>
                      <td>200</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANNANYA-NSUBRAMANIAN-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2058</td>
                      <td>ANANYA DHOKE</td>
                      <td>201</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANANYA-DHOKE-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1325</td>
                      <td>ADITYA GOSAIN</td>
                      <td>197</td>
                      <td>12.05.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ADITYA-GOSAIN-X.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3748</td>
                      <td>ADHIRAJ SAS</td>
                      <td>71</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ADHIRAJ-SAS.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3299</td>
                      <td>AMYRA TANDON</td>
                      <td>71</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/AMYRA-TANDON.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/159</td>
                      <td>aryan bakshi</td>
                      <td>214</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/aryan-bakshi.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2970</td>
                      <td>HRIDYANSH GAUTAM</td>
                      <td>70</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/HRIDYANSH-GAUTAM.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2986</td>
                      <td>ishika jain</td>
                      <td>219</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ishika-jain.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1223</td>
                      <td>KRISHIV KETAN JALAL</td>
                      <td>70</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KRISHIV-KETAN-JALAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2638</td>
                      <td>KRISH NARANG</td>
                      <td>146</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KRISH-NARANG.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/533</td>
                      <td>MAHI KETAN JALAL</td>
                      <td>70</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/MAHI-KETAN-JALAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4293</td>
                      <td>TANMAY GARG</td>
                      <td>72</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/TANMAY-GARG.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2895</td>
                      <td>TAVISH SINGHAL</td>
                      <td>71</td>
                      <td>12.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/TAVISH-SINGHAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3288</td>
                      <td>Zohaid Shafi</td>
                      <td>185</td>
                      <td>08.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ZOHAID-SHAFI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4474</td>
                      <td>Trishaan Agarwal</td>
                      <td>181</td>
                      <td>08.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/TRISHAAN-AGARWAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3275</td>
                      <td>Jai Dua</td>
                      <td>71</td>
                      <td>08.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/JAI-DUA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3130</td>
                      <td>Atharva</td>
                      <td>184</td>
                      <td>08.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ATHARVA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4240</td>
                      <td>Anika Sharma</td>
                      <td>82</td>
                      <td>08.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANIKA-SHARMA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2057</td>
                      <td>Myra Dhoke</td>
                      <td>70</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/MYRA-DHOKE.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4266</td>
                      <td>Kasturi Kulkarni</td>
                      <td>149</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/KASTURI-KULKARNI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4414</td>
                      <td>Ishita Madhok</td>
                      <td>174</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ISHITA-MADHOK.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1056</td>
                      <td>Arjun Narang</td>
                      <td>147</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ARJUN-NARANG.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2945</td>
                      <td>Antariksh</td>
                      <td>160</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ANTARIKSH.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3906</td>
                      <td>Adiah Qadri</td>
                      <td>73</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ADIAH-QADRI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4320 </td>
                      <td>Achintya Gupta</td>
                      <td>162</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ACHINTYA-GUPTA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3969 </td>
                      <td>Rishita Mahajan</td>
                      <td>154</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/RISHITA-MAHAJAN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4386</td>
                      <td>Shireen Vij</td>
                      <td>70</td>
                      <td>06.04.21</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SHIREEN-VIJ.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2786 </td>
                      <td>Shashwat Bahri</td>
                      <td>247</td>
                      <td>30.03.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/Shashwat-Bahri.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/2922 </td>
                      <td>Akshaj Bhardwaj</td>
                      <td>263</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/AKSHAJ-BHARDWAJ.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3845</td>
                      <td>Arav Kumar</td>
                      <td>234</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ARAV-KUMAR.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3885</td>
                      <td>Aryan Mann</td>
                      <td>236</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ARYAN-MANN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/88</td>
                      <td>Asmit Bohra</td>
                      <td>239</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/ASMIT-BOHRA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2011</td>
                      <td>Ayush Dasgupta</td>
                      <td>242</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/AYUSH-DASGUPTA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1260</td>
                      <td>Dhairya Kedia</td>
                      <td>167</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/DHAIRYA-KEDIA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1260</td>
                      <td>Faiq Imtiaz</td>
                      <td>44</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/FAIQ-IMTIAZ.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4270</td>
                      <td>Harshvardhan</td>
                      <td>50</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/HARSHVARDHAN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2871</td>
                      <td>Mamilla Sai Nayan</td>
                      <td>230</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/MAMILLA-SAI NAYAN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2612</td>
                      <td>Rana Yuvraj</td>
                      <td>267</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/RANA-YUVRAJ.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2804</td>
                      <td>Rishita Makde</td>
                      <td>240</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/RISHITA-MAKDE.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/4314</td>
                      <td>Samarth Raman</td>
                      <td>220</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SAMARTH-RAMAN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1580</td>
                      <td>Sarisha Nowal</td>
                      <td>237</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SARISHA-NOWAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/239</td>
                      <td>Shreya Bajaj</td>
                      <td>232</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SHREYA-BAJAJ.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3558</td>
                      <td>Syna Gogia</td>
                      <td>264</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/SYNA-GOGIA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2351</td>
                      <td>Tanya Gupta</td>
                      <td>238</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/TANYA-GUPTA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/3898</td>
                      <td>Utkarsh Mishra</td>
                      <td>262</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/UTKARSH-MISHRA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3581</td>
                      <td>Varnika Sharma</td>
                      <td>42</td>
                      <td>06.08.20</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc/VARNIKA-SHARMA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1969 </td>
                      <td>Bhavya Chadha</td>
                      <td> 105</td>
                      <td>21.11.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-bhavya-chadha.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2243 </td>
                      <td>Evaan Goel</td>
                      <td>104</td>
                      <td>21.11.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-EVAAN-GOEL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3279</td>
                      <td>Meher Nigam</td>
                      <td>104</td>
                      <td>21.11.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-MEHER-NIGAM.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2282</td>
                      <td>Oishee Jana</td>
                      <td>106</td>
                      <td>21.11.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-OISHEE-JANA.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2869 </td>
                      <td>Pranav Kansal</td>
                      <td>81</td>
                      <td>21.11.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-PRANAV-KANSAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1059</td>
                      <td>TanishkKa Aggarwal</td>
                      <td>95</td>
                      <td>21.11.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-TANISHKA-AGARWAL.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1241</td>
                      <td>Abhisneha Sinha</td>
                      <td>300</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-abhisneha-sinha.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2999</td>
                      <td>Ahaan Ganguly</td>
                      <td>294</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-ahaan-ganguly.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3624</td>
                      <td>Ananya Jain</td>
                      <td>298</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-ananya-jain.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3490</td>
                      <td>Anirudh Yarram</td>
                      <td>296</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-anirudh-yarram.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/45</td>
                      <td>Anshrutha Srinivas</td>
                      <td>297</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-anshrutha-srinivas.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2927</td>
                      <td>Devanshi Maheshwari</td>
                      <td>301</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-devanshi-maheshwari.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2419</td>
                      <td>Pratham Mittal</td>
                      <td>299</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-pratham-mittal.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3576</td>
                      <td>Raushni Plaha</td>
                      <td>292</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-raushni-plaha.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2140</td>
                      <td>Shreeya Chugh</td>
                      <td>293</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-shreeya-chugh.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/3459</td>
                      <td>Simran Kaur Sachdeva</td>
                      <td>295</td>
                      <td>10.05.19</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/tc-simran-kaur-sachdeva.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>

                    <tr>
                      <td>LVG/660</td>
                      <td>Arohi Varsh</td>
                      <td>280</td>
                      <td>30.09.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-arohi.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/439</td>
                      <td>Dev Aditya Joshi</td>
                      <td>281</td>
                      <td>19.09.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-DEV-ADITYA-JOSHI.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/0644</td>
                      <td>Khusshi Arora</td>
                      <td>279</td>
                      <td>15.09.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Khusshi-Arora.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/0013</td>
                      <td>Rabani Gautam</td>
                      <td>275</td>
                      <td>30.09.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Rabani-Gautam.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1285</td>
                      <td>Saihaj Kaur</td>
                      <td>284</td>
                      <td>15.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Saihaj-Kaur.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2484</td>
                      <td>Siya Karba</td>
                      <td>281</td>
                      <td>15.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Siya-Karba.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/852</td>
                      <td>Swastika Chakraborty</td>
                      <td>286</td>
                      <td>15.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-SWASTIKA-C.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/931</td>
                      <td>Vandit Bhatia</td>
                      <td>285</td>
                      <td>15.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Vandit-Bhatia.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/787</td>
                      <td>Veer Arjun Manuja</td>
                      <td>262</td>
                      <td>03.07.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Veer-Arjun.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/153</td>
                      <td>Varun</td>
                      <td>194</td>
                      <td>16.03.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-VARUN.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2561</td>
                      <td>Addhayan Bakhshi</td>
                      <td>287</td>
                      <td>15.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Addhayan.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2009</td>
                      <td>Yuvraj Tanwar</td>
                      <td>288</td>
                      <td>14.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Yuvraj-Tanwar.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1172</td>
                      <td>Anshika Chaudhary</td>
                      <td>289</td>
                      <td>17.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-anshika.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/552</td>
                      <td>Bisman Kaur</td>
                      <td>290</td>
                      <td>19.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-bisman.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2096</td>
                      <td>Tripatalam Singh Marahaar</td>
                      <td>291</td>
                      <td>28.10.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-tripatalam.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2106</td>
                      <td>Akshita</td>
                      <td>297</td>
                      <td>30.11.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Akshita.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/201</td>
                      <td>Aryan Kumar</td>
                      <td>292</td>
                      <td>30.11.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Aryan-Kumar.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/828</td>
                      <td>Ayaan Gupta</td>
                      <td>295</td>
                      <td>30.11.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Ayaan-Gupta.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/652</td>
                      <td>Mohammed Abdussamad</td>
                      <td>296</td>
                      <td>30.11.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Mohammed-Abdussamad.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/2497</td>
                      <td>Nikhil Arora</td>
                      <td>293</td>
                      <td>30.11.15</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Nikhil-Arora.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/720</td>
                      <td>Riya Kashyap</td>
                      <td>338</td>
                      <td>19.03.16</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Riya-Kashyap.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/721</td>
                      <td>Tanuj Kasyap</td>
                      <td>337</td>
                      <td>19.03.16</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Tanuj-Kasyap.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1461</td>
                      <td>Shlok Bhatnagar </td>
                      <td>369</td>
                      <td>26.02.16</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Shlok.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1460</td>
                      <td>Stuti Bhatnagar</td>
                      <td>322</td>
                      <td>19.03.16</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-OF-Stuti.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1585</td>
                      <td>Vihaan Pruthi</td>
                      <td>401</td>
                      <td>10.06.16</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/TC-Vihaan.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                    <tr>
                      <td>LVG/1093</td>
                      <td>Kabir Mittal</td>
                      <td>407</td>
                      <td>25.05.16</td>
                      <td>
                        <Link
                          to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/KABIR-TC.pdf"
                          className="downloadpdf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          PDF Download Here
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Tc;
